<template>
    <div class="recruitment">
        <page-cover image-url="/images/recruitment.jpg" title="Work where you Love" description="Working in the Early Years industry can be both rewarding and fulfilling. We want to offer exciting and diverse careers to all candidates that are seeking them. Whatever your goals are for your personal career, we will assist you in achieving that goal and progress even further." />
        <section>
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-12">
                    <div class="lg:col-span-1">
                        <h3 class="text-primary text-3xl font-semibold">Join our talent pool</h3>
                        <p class="mt-6">Join our talent pool and become part of a vibrant and dynamic community of childcare professionals. By joining our talent pool, you will have the opportunity to connect with top employers, stay updated on the latest job openings, and be considered for exciting career opportunities.</p>
                        <p class="mt-4">Fill out our application form today, showcase your potential, and embark on a journey towards a fulfilling and rewarding professional future.</p>
                    </div>
                    <div class="lg:col-span-2">
                        <form class="register-form light-gray-bg p-4 lg:p-8" @submit.prevent="submitForm">
                            <div class="grid lg:grid-cols-2 gap-4">
                                <div>
                                    <label for="first-name">First Name<sup>*</sup></label>
                                    <input type="text" id="first-name" v-model="JobApplicationData.FirstName" required>
                                </div>
                                <div>
                                    <label for="last-name">Last Name<sup>*</sup></label>
                                    <input type="text" ic="last-name" v-model="JobApplicationData.LastName" required>
                                </div>
                            </div>
                            <div class="grid lg:grid-cols-2 gap-4 mt-4">
                                <div>
                                    <label for="email-id">Email Address<sup>*</sup></label>
                                    <input type="email" id="email-id" v-model="JobApplicationData.Email" required>
                                </div>
                                <div>
                                    <label for="contact-no">Contact Number<sup>*</sup></label>
                                    <input type="tel" id="contact-no" v-model="JobApplicationData.Phone" required>
                                </div>
                            </div>
                            <div class="grid lg:grid-cols-2 gap-4 mt-4">
                                <div>
                                    <label for="location">Location</label>
                                    <input type="text" id="location" v-model="JobApplicationData.Location">
                                </div>
                                <div>
                                    <label for="dob">Date of Birth</label>
                                    <Datepicker v-model="JobApplicationData.DOB" placeholder="DD/MM/YYYY" text-input auto-apply :close-on-auto-apply="true" :enable-time-picker="false" :max-date="new Date()" format="dd/MM/yyyy" />
                                </div>
                            </div>
                            <div class="mt-4">
                                <label for="experience-year">How many years of childcare experience do you have?</label>
                                <input type="text" id="experience-year" v-model="JobApplicationData.ExperienceYear">
                            </div>
                            <div class="mt-4">
                                <label for="experience">Brief description of your experience in child care.</label>
                                <textarea id="experience" rows="4" v-model="JobApplicationData.ExperienceDetails"></textarea>
                            </div>
                            <div class="mt-4">
                                <label for="qualifications">Qualifications</label>
                                <input type="text" id="qualifications" v-model="JobApplicationData.Qualifications">
                            </div>
                            <div class="grid lg:grid-cols-2 gap-4 mt-4">
                                <div>
                                    <label for="work-type">What sort of work are you looking for?</label>
                                    <select id="work_type" v-model="JobApplicationData.WorkType">
                                        <option disabled value="">Please select ...</option>
                                        <option value="Full Time">Full Time</option>
                                        <option value="Part Time">Part Time</option>
                                        <option value="Term Time">Term Time</option>
                                    </select>
                                </div>
                                <div>
                                    <label for="dbs">Do you have a current DBS?</label>
                                    <select id="dbs" v-model="JobApplicationData.DBS">
                                        <option disabled value="">Please select ...</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                            <!-- <div class="mt-6">
                                <label class="mr-4 inline" for="upload">Attach your latest CV</label>
                                <input type="file" id="upload" class="mt-4 lg:mt-0" @change="uploadFile" />
                            </div> -->
                            <div class="mt-8">
                                <button class="btn btn-secondary btn-full" :disabled="isFormValid">
                                    <span v-if="!isLoading">Submit Form</span>
                                    <span v-if="isLoading">Sending...</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section class="section-bg">
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <h3 class="text-primary text-3xl font-semibold">Recent Job Openings</h3>
                <div class="mt-12">
                    <job v-for="(job, index) in latestJobs" :key="index" :title="job.Title" :company="job.Company" :location="job.Location" :description="job.Description" :nav-to="job._path" />
                </div>
            </div>
        </section>
        <section v-if="showFaqs">
            <div class="px-4 lg:px-12 md:container md:mx-auto py-12 lg:py-32">
                <div class="lg:mx-40">
                    <h3 class="text-primary text-3xl font-semibold text-center">Frequently Asked Questions</h3>
                    <p class="text-center mt-8">Remember that specific FAQs may vary depending on the organization or location. Tailor the FAQs to align with your recruitment process and provide the most relevant information for potential candidates.</p>
                    <div class="mt-12">
                        <div v-for="(faq, index) in faqs" :key="index" class="faq" @click="openFaq(index)">
                            <div class="faq--question" :class="{ expand: activeFAQ === index }">
                                {{ faq.question }}
                            </div>
                            <div class="faq--answer" :class="{ 'faq--answer--show': activeFAQ === index }">
                                <ContentRenderer class="nuxt-content" :value="faq" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import dayjs from 'dayjs';
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import Swal from 'sweetalert2';

const isLoading = ref(false);
const JobApplicationData = reactive({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Location: '',
    DOB: '',
    ExperienceYear: '',
    ExperienceDetails: '',
    Qualifications: '',
    WorkType: '',
    DBS: ''
});
const message = reactive({
    to: ['admin@early-years.com'],
    subject: '',
    content: ''
})
const { data: latestJobs } = await useAsyncData('latestJobs', () => 
    queryContent('/jobs').where({ Active: true }).sort({ PublishDate: -1 }).limit(5).find()
);
const { data: faqs } = await useAsyncData('faqs', () => 
    queryContent('/faqs').sort({ Order: 1, $numeric: true }).find()
);
const showFaqs = computed(() => {
    return faqs.value && faqs.value.length > 0;
})
const activeFAQ = ref(null)
function openFaq(index) {
    if (activeFAQ.value === index) {
        activeFAQ.value = null;
    } else {
        activeFAQ.value = index;
    }
};

function resetData() {
    JobApplicationData.FirstName = '',
    JobApplicationData.LastName = '',
    JobApplicationData.Email = '',
    JobApplicationData.Phone = '',
    JobApplicationData.Location = '',
    JobApplicationData.DOB = '',
    JobApplicationData.ExperienceYear = '',
    JobApplicationData.ExperienceDetails = '',
    JobApplicationData.Qualifications = '',
    JobApplicationData.WorkType = '',
    JobApplicationData.DBS = ''
}

const isFormValid = computed(() => {
    return (
        isLoading.value ||
        !JobApplicationData.FirstName ||
        !JobApplicationData.LastName ||
        !JobApplicationData.Email ||
        !JobApplicationData.Phone
    )
})
// const uploadFile = (e) => {
//     file.value = e.target.files[0];
// }
async function submitForm() {
    isLoading.value = true;
    message.subject = `You have a new registration from ${JobApplicationData.FirstName} ${JobApplicationData.LastName} via Early Years Recruitment website`;

    message.content = "<h2>You have a new registration from <span style='color:#64B5D0'>" + JobApplicationData.FirstName + ' ' + JobApplicationData.LastName + "</span> via Early Years Recruitment website</h2>" +
        "<strong>Name: </strong>" + JobApplicationData.FirstName + ' ' + JobApplicationData.LastName + "<br />" +
        "<strong>Email: </strong>" + JobApplicationData.Email + "<br />" +
        "<strong>Phone: </strong>" + JobApplicationData.Phone + "<br />";
        if (JobApplicationData.Location)
            message.content += "<strong>Location: </strong>" + JobApplicationData.Location + "<br />";

        if (JobApplicationData.DOB)
            message.content += "<strong>Date of birth: </strong>" + dayjs(JobApplicationData.DOB).format('DD/MM/YYYY') + "<br />";

        if (JobApplicationData.ExperienceYear)
            message.content += "<strong>How many years of childcare experience do you have?: </strong>" + JobApplicationData.ExperienceYear + "<br />";

        if (JobApplicationData.ExperienceDetails)
            message.content += "<strong>Brief description of your experience in child care: </strong>" + JobApplicationData.ExperienceDetails + "<br />";

        if (JobApplicationData.Qualifications)
            message.content += "<strong>Qualifications: </strong>" + JobApplicationData.Qualifications + "<br />";

        if (JobApplicationData.WorkType)
            message.content += "<strong>What sort of work are you looking for?: </strong>" + JobApplicationData.WorkType + "<br />";

        if (JobApplicationData.DBS)
            message.content += "<strong>Do you have a current DBS?: </strong>" + JobApplicationData.DBS + "<br />";

        // const formData = new FormData();
        // formData.append("message", message);
        // formData.append("attachment", file.value); // Append the attachment file to the FormData
        // console.log(file.value);
        try {
            const { data: result } = await $fetch('/api/sendJobApplication', {
                method: 'post',
                // headers: { 'Content-Type': 'multipart/form-data' },
                body: message
            });
            if(result) {
                await Swal.fire({
                    icon: 'success',
                    title: 'Thanks for Registering with Early Years',
                    text: 'Our recruitment team will get back to you in 48 hours.',
                    confirmButtonColor: '#313131',
                });
                isLoading.value = false;
                resetData();
            }
        } catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'An Error Occurred',
                text: 'Some error has occurred',
                confirmButtonColor: '#313131',
            });
            isLoading.value = false;
            resetData();
        }

}
useHead({
    title: 'Recruitment',
    link: [
        { rel: 'preload', as: 'image', href: '/images/recruitment.jpg', fetchpriority: 'high' },
    ],
});
</script>

<style lang="scss" scoped>
.recruitment {
    .faq {
        padding: 16px 12px;
        background: #f0f0f0;
        margin-bottom: 16px;
        border-radius: 4px;
        &--question {
            cursor: pointer;
            color: #3c3c3c;
            font-weight: 600;
            position: relative;
            padding-right: 20px;
            &:before,
            &:after {
                position: absolute;
                content: '';
                top: 8px;
                right: 0;
                width: 16px;
                height: 2px;
                background: $brand-secondary;
            }
            &:after {
                transform-origin: center;
                transform: rotate(90deg);
            }
            &.expand {
                &:after {
                    height: 0;
                }
            }
        }
        &--answer {
            padding-top: 16px;
            display: none;
            transition: opacity 2s ease-out;
            opacity: 0;
            &--show {
                display: block;
                opacity: 1;
                transition: opacity 2s ease-out;
            }
        }
    }
}
:deep() {
    .dp__input {
        background-color: $white;
        height: 48px;
        border-radius: 3px;
        border: none;
        &::placeholder {
            color: #313131;
            opacity: 1;
        }
    }
    .dp__action_button {
        font-size: 13px;
    }
}
</style>